<script setup>
import axios from "axios";
import { useWebsiteStore } from "@/stores/website";
import { storeToRefs } from "pinia";
import { ref } from "vue";
import { useUserStore } from "@/stores/user";
import TreeviewStructureFull from "@/components/PagePicker/TreeviewStructureFull.vue";

const websiteStore = useWebsiteStore();

const {lastUpdated, website, pageList} = storeToRefs(websiteStore);
const busy = ref(false)
const userStore = useUserStore();

async function runScan() {
  const myModal = bootstrap.Modal.getInstance(document.getElementById('modal-scan-again'))
  busy.value = true
  let pages = selectedPages.value
  try {
    let r = await axios.post(`websites/${website.value.shortuuid}/add-pages/`, {
      pages: pages
    })
  } catch (e) {
    if (e.response.status >= 400) {
      if (e.response.data.code === 'subscription') {
        userStore.showNotification('plan')
      } else if (e.response.status === 401) {
        userStore.showNotification('login')
      }
    }
  }
  busy.value = false
  myModal.hide()
}

const maxPages = ref(100)

function format(v) {
  return `${v} pages`
}

const selectedPages = ref([])
const scanType = ref('full')
function selectPages(pages){
  selectedPages.value = pages;
}
</script>

<template>
  <div
      class="modal"
      id="modal-scan-again"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-scan-again"
      aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">

        <div class="block-rounded block-transparent block mb-0">
          <div class="block-header block-header-default">
            <h3 class="block-title"> Select Pages </h3>
            <div class="block-options space-x-1">
              <button type="button" class="btn-block-option" data-bs-dismiss="modal" aria-label="Close"><i
                  class="fa fa-fw fa-times"></i></button></div>
          </div>
          <div class="block-content fs-sm p-0">
            <treeview-structure-full :force-root-selection="false" @select-page="selectPages" parent-path="seo-summary" :pageList="pageList"></treeview-structure-full>

          </div>
          </div>
          <div class="block-content block-content-full d-flex justify-content-between align-items-center bg-body">
            <div class="d-flex align-items-center">
              <label class="form-label mb-0 me-2" for="scan-type">Scan Type:</label>
              <select id="scan-type" class="form-select form-select-sm" v-model="scanType" style="width: 150px;">
                <option value="full">Full Scan</option>
                <option value="quick">Quick Scan</option>
              </select>
            </div>
            <div>
              <button
                  type="button"
                  class="btn btn-sm btn-alt-secondary me-1"
                  data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                  type="button"
                  class="btn btn-sm btn-primary"
                  @click.prevent="runScan"
                  :disabled="busy || selectedPages.length === 0"
              ><span v-if="busy" class="spinner-border spinner-border-sm"></span>
                Scan {{selectedPages.length}} Pages
              </button>
            </div>
          </div>
        </div>
        </div>
      </div>

</template>

<style>
.scan-again-list {

  &:hover {
    background-color: #f8f9fa;
  }

  background-color: white;
  padding: 10px;
  border-bottom: 1px solid #f7f7f7;
}

</style>